import React, { useEffect, useState, useRef } from "react"
import Components from "../index"
import IconV2 from "../icon-v2"
import {
  StyledModal,
  StyledModalMain,
  StyledModalContent,
  StyledModalHeader,
  StyledModalHeaderTop,
  StyledModalHeaderArrow,
  StyledModalTitle,
  StyledModalNav,
  StyledModalBG,
} from "./partials"
import { blokType } from "../../types"

export interface ModalProps {
  title: string
  onClick: any
  visible: boolean
  content: blokType[]
  prevModal: any
  nextModal: any
  disbableNext: boolean
  disbablePrev: boolean
  accent_color: string
  noOfCards: number
}

export const S22Modal: React.FC<ModalProps> = ({
  title,
  onClick,
  visible,
  content,
  prevModal,
  nextModal,
  disbableNext,
  disbablePrev,
  accent_color,
  noOfCards,
}) => {
  const sentinalRef = useRef()
  const [stuck, setStuck] = useState(false)

  if (sentinalRef && sentinalRef.current) {
    const handler = (value) => {
      if (!value[0].isIntersecting) {
        setStuck(true)
      } else {
        setStuck(false)
      }
    }

    const observer = new window.IntersectionObserver(handler)
    observer.observe(sentinalRef.current)
  }

  return (
    <>
      <StyledModal visible={visible}>
        <div ref={sentinalRef} className="sentinal"></div>
        <StyledModalMain>
          <StyledModalHeader>
            <StyledModalHeaderTop>
              {prevModal && noOfCards > 1 && !disbablePrev && (
                <StyledModalHeaderArrow onClick={prevModal}>
                  <IconV2 icon="arrow-left" size="24" />
                </StyledModalHeaderArrow>
              )}
              {title && <StyledModalTitle>{title}</StyledModalTitle>}
              {nextModal && noOfCards > 1 && !disbableNext && (
                <StyledModalHeaderArrow onClick={nextModal}>
                  <IconV2 icon="arrow-right" size="24" />
                </StyledModalHeaderArrow>
              )}
            </StyledModalHeaderTop>
          </StyledModalHeader>
          <StyledModalNav
            stuck={stuck}
            noTitle={content && content[0].title.length < 1 && true}
          >
            {content &&
              content.length > 0 &&
              content.map((content: blokType, idx) => (
                <a key={content._uid} href={"#" + content._uid + "-" + idx}>
                  {content.title}
                </a>
              ))}
          </StyledModalNav>
          {content && content.length > 0 && (
            <StyledModalContent noTitle={content && content[0].title.length < 1 && true}>
              {content.map((content: blokType, idx) =>
                React.createElement(Components(content.component), {
                  key: content._uid + "-" + idx,
                  id: content._uid + "-" + idx,
                  blok: content,
                  accent_color: accent_color,
                })
              )}
            </StyledModalContent>
          )}
        </StyledModalMain>
        <StyledModalBG onClick={onClick} />
      </StyledModal>
    </>
  )
}
